import axiosConfig from '../modules/axiosConfig'
import utils from '../modules/utils'
const HTTP = axiosConfig.HTTP

// state
const state = {
  loadingUpdateClient: false
}

// getters
const getters = {
  getloadingUpdateClient () {
    return state.loadingUpdateClient
  }
}

// actions
const actions = {
  async updateClient ({ commit, rootState }, data) {
    commit('LOADING_UPDATECLIENT_FINISHED', false)
    let fecnac = null
    if (data && data.fecnac && data.fecnac.valueDate && typeof data.fecnac.valueDate.getMonth === 'function') {
      data.fecnac.valueDate.setTime(data.fecnac.valueDate.getTime() - data.fecnac.valueDate.getTimezoneOffset() * 60 * 1000)
      fecnac = data.fecnac.valueDate.toISOString().split('T')[0]
    } else {
      fecnac = data.fecnac.valueDate
    }
    const config = rootState.appConfig.configFile
    const appParams = JSON.parse(sessionStorage.getItem('appParams'))
    const storageAppToken = sessionStorage.getItem('token')
    const hashToken = utils.SHA256(`${appParams.entidad}${storageAppToken}${appParams.canal}`)
    let body = {}
    if (typeof data !== 'undefined') {
      body = Object.assign({}, {
        runService: {
          opData: {
            avanzar: false,
            businesstimeout: '',
            canal: config.canal,
            claveFin: '',
            claveInicio: '',
            entidad: config.entidad,
            idioma: data.idioma ? data.idioma.toUpperCase() : 'ES',
            indMasDatos: 'N',
            oficina: '',
            pantPagina: '',
            retroceder: false,
            mainUser: appParams.mainUser,
            securityToken: hashToken
          },
          eEntrada: {
            apellid1: data.apellid1 ? data.apellid1.trim() : '',
            apellid2: data.apellid2 ? data.apellid2.trim() : '',
            codentid: data.codentid ? data.codentid.trim() : '',
            codpostal: data.codpostal,
            codregion: data.codregion ? data.codregion : '',
            desclave1: data.desclave1 ? data.desclave1.trim() : '',
            desclave2: data.desclave2 ? data.desclave2.trim() : '',
            fecnac: fecnac || '',
            idclient: data.idclient ? data.idclient.trim() : '',
            indestciv: data.indestciv,
            indexiste: data.indexiste,
            nombre: data.nombre ? data.nombre.trim() : '',
            poblacion: data.poblacion ? data.poblacion.trim() : '',
            sexo: data.sexo ? data.sexo.trim() : '',
            tipidcli: data.tipidcli ? data.tipidcli.trim() : '',
            tipmedio1: data.tipmedio1 ? data.tipmedio1.trim() : '',
            tipmedio2: data.tipmedio2 ? data.tipmedio2.trim() : ''
          }
        }
      })
    }
    try {
      console.log('data', data)
      console.log('body', body)
      const response = await HTTP.post(config.endpoints.updateClient, body)
      console.log('response', response)
      sessionStorage.setItem('token', response.data.runServiceResponse.return.securityToken)
      commit('LOADING_UPDATECLIENT_FINISHED', true)
      if (response.data.runServiceResponse.return.retorno === '039') {
        commit('SET_ERROR', {
          isError: true,
          isFatal: true,
          msg: 'La sesión ha expirado. Reinicie el registro.'
        })
      } else if (response.data.runServiceResponse.return.retorno === '021') {
        commit('SET_ERROR', {
          isError: true,
          isFatal: true,
          msg: 'Token de seguridad incorrecto.'
        })
      }
      return response.data.runServiceResponse.return
    } catch (error) {
      console.log(error)
      commit(
        'SET_ERROR', {
          isError: true,
          isFatal: false,
          msg: error
        }, { root: true }
      )
    }
  }
}

// mutations
const mutations = {
  LOADING_UPDATECLIENT_FINISHED (state, actions) {
    state.loadingUpdateClient = actions
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
